import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border flex-shrink-0">
      <div className="px-3 sm:px-4 lg:px-6 py-3 sm:py-4 overflow-x-hidden">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-muted-foreground">
          <p className="text-center sm:text-left">
            &copy; {new Date().getFullYear()} NAndroidEx. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-foreground hover:underline underline-offset-4">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-foreground hover:underline underline-offset-4">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
